import ja from './ja.json';
import en from './en.json';

const languages: {[index: string]: any} = {};
languages['en'] = en;
languages['ja'] = ja;
export default languages;
